export default __webpack_public_path__ + "static/media/walk_swing_arms.52bfde10.gif";